export default __webpack_public_path__ + "static/hero-0378e74555b43214ee556ad68b6b0dd8.jpg";